import React from 'react';

import css from './EventCard.module.css';
import { formatDateMed } from '../../../../../../../lib/date';
import EntityPill from '../../../../../../../components/EntityPill/EntityPill';
import BriefPill from '../../../../../../../components/BriefPill/BriefPill';
import Source from '../../../../../Source/Source';

function EventCard({ event }) {
  return (
    <div className={css.main} data-cy="event-card">
      <div className={css.title} data-cy="event-title">
        {event.title}
      </div>
      <div className={css.date} data-cy="event-date">
        {formatDateMed(event.date)}
      </div>
      <div className={css.entities} data-cy="event-entities">
        {event.entities.map((entity) => (
          <EntityPill
            key={entity.id}
            id={entity.id}
            autoOpenDossier
            name={entity.name}
            image={entity.image}
            isConnected={entity.isConnected}
            inSubscription={entity.inSubscription}
            type={entity.type}
            size="small"
          />
        ))}
      </div>
      <div className={css.briefs} data-cy="event-briefs">
        {event.briefs.map((brief) => (
          <BriefPill key={brief.id} name={brief.name} />
        ))}
        {event.countries.map((country) => (
          <BriefPill key={country.id} name={country.name} isGeography />
        ))}
      </div>
      <div className={css.sources} data-cy="event-sources">
        {event.sources.map((source) => (
          <Source src={source} key={source} />
        ))}
      </div>
    </div>
  );
}

export default EventCard;
